var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7542_201080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20947 20.0104H5.70947V9.43043C5.70947 7.51043 7.27947 5.94043 9.20947 5.94043C11.1395 5.94043 12.7095 7.51043 12.7095 9.44043V14.4304C12.7095 15.6504 13.6995 16.6404 14.9195 16.6404C16.1395 16.6404 17.1295 15.6504 17.1295 14.4304V9.62043H18.6295V14.4304C18.6295 16.4804 16.9595 18.1404 14.9195 18.1404C12.8795 18.1404 11.2095 16.4704 11.2095 14.4304V9.43043C11.2095 8.33043 10.3095 7.43043 9.20947 7.43043C8.10947 7.43043 7.20947 8.33043 7.20947 9.43043V20.0004V20.0104Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2795 6.78027H15.4795V12.1903H20.2795V6.78027Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0095 5.28023C18.5495 5.28023 18.9895 5.72023 18.9895 6.26023V7.00023H16.7695V6.26023C16.7695 5.72023 17.2095 5.28023 17.7495 5.28023H18.0095M18.0095 3.99023H17.7495C16.4895 3.99023 15.4795 5.01023 15.4795 6.26023V8.29023H20.2795V6.26023C20.2795 5.00023 19.2595 3.99023 18.0095 3.99023V3.99023Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7542_201080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 16.02,
    fill: "white",
    transform: "translate(5.70947 3.99023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.33aa87d3c6966390c4531278dba54d65.svg";
export { ForwardRef as ReactComponent };